import React from "react";
import Svg, { Path } from "react-native-svg";

const Speed = (props) => {
  const { color = "#fff", height = 14, width = 14 } = props;

  return (
    <Svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.0829 7.12813L9.17735 4.61172L7.98125 6.98581C7.918 7.11136 7.74894 7.1422 7.64486 7.04719L0.420672 0.452739C0.340985 0.379998 0.331481 0.25959 0.398744 0.174914C0.465312 0.0911151 0.585547 0.0694868 0.677492 0.124773L6.65645 3.71992L8.18965 0.837725C8.25394 0.716867 8.41732 0.687132 8.52062 0.777489L13.4726 5.10919L14.0038 4.32128C14.1036 4.17334 14.3341 4.20574 14.3852 4.37488L15.51 8.09463C15.5516 8.23215 15.441 8.36927 15.2942 8.36217L11.6636 8.18658C11.4922 8.17829 11.4021 7.98514 11.5077 7.85223L12.0829 7.12813Z"
        fill="#FF0000"
      />
    </Svg>
  );
};

export default Speed;
